export default __webpack_public_path__ + "static/B0047-1853ab6eed526fe00686a955eb5180ec.png";